module.exports = __webpack_public_path__ + "img/HiwaQader-Ga.6756c4a8.jpg";